'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import type { z } from 'zod';
function useValidatedParams(schema) {
  const $ = _c(3);
  const params = useParams();
  let t0;
  if ($[0] !== params || $[1] !== schema) {
    t0 = schema.safeParse(params);
    $[0] = params;
    $[1] = schema;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const validated = t0;
  if (!validated.success) {
    return null;
  }
  return validated.data;
}
export default useValidatedParams;